export const keypadValues = {
  'kp-0': '0',
  'kp-1': '1',
  'kp-2': '2',
  'kp-3': '3',
  'kp-4': '4',
  'kp-5': '5',
  'kp-6': '6',
  'kp-7': '7',
  'kp-8': '8',
  'kp-9': '9',
  'kp-closep': ') ',
  'kp-comma': ',',
  'kp-div': '/ ',
  'kp-dot': '.',
  'kp-eq': '= ',
  'kp-exp': '^',
  'kp-gt': '> ',
  'kp-lt': '< ',
  'kp-minus': '- ',
  'kp-mul': '* ',
  'kp-openp': '(',
  'kp-plus': '+ '
};
